import { useDispatch } from 'react-redux';
import { setNavItems } from 'src/redux/navItems/navItemsSlice';
import { setUserData } from 'src/redux/user/userSlice';
import useApi from '../useApi';

export const useLogout = () => {
  const dispatch = useDispatch();

  const {
    data: logoutData,
    loading: logoutLoading,
    error: logoutErr,
    postData,
  } = useApi('/Common/logout');

  const logout = async () => {
    const res = await postData();

    if (res && res.status === true) {
      //const keysToKeep = [
      //  'dastatuses',
      //  'states',
      //  'countries',
      //  'commonstatuses',
      //  'businesstypes',
      //  'userroles',
      //];

      //Object.keys(localStorage).forEach((key) => {
      //  if (!keysToKeep.includes(key)) {
      //    localStorage.removeItem(key);
      //  }
      //});

      dispatch(
        setUserData({
          userId: '',
          dspId: '',
          roleId: '',
          userInfo: {},
          isAuthenticated: false,
        }),
      );
      dispatch(setNavItems([]));

      // Wait a tick, then reload to clear any cached chunks
      //setTimeout(() => {
      //  window.location.reload();
      //}, 300);
    } else {
      // Force reload with cache-busting parameter to avoid stale chunks
      window.location.href = `${window.location.origin}/#/?t=${Date.now()}`;
    }
  };

  return { logoutData, logoutLoading, logoutErr, logout };
};
